import { Path } from "react-native-svg";
import CustomIcon, { CustomIconProps } from "./CustomIcon";

const QRCode: React.FC<CustomIconProps> = (props) => (
  <CustomIcon {...props}>
    <Path clipRule="evenodd" d="M14 15V14H11V11H14V13H16V15H15V17H13V19H11V16H13V15H14ZM19 19H15V17H17V15H19V19ZM1 1H9V9H1V1ZM3 3V7H7V3H3ZM11 1H19V9H11V1ZM13 3V7H17V3H13ZM1 11H9V19H1V11ZM3 13V17H7V13H3ZM16 11H19V13H16V11ZM4 4H6V6H4V4ZM4 14H6V16H4V14ZM14 4H16V6H14V4Z" fillRule="evenodd" /> 
  </CustomIcon>
);

export default QRCode;